module.exports = __webpack_public_path__ + "img/norway-neoplasm-female.1b4fa133.png";